var Acr = Acr || {};

Acr.Accessories = function ($element) {
  

  var currentBreakpoint;
  var $accessoriesSliders;

  function initSlick() {
    $accessoriesSliders = $($element).slick({
      dots: true,
      prevArrow: '<svg class="acr-icon slick-prev slick-arrow"'
                + ' viewBox="0 0 26 26">'
                + '<use xmlns:xlink="http://www.w3.org/1999/xlink"'
                + ' xlink:href="#arrow-left">'
                + ' </use></svg>',
      nextArrow: '<svg class="acr-icon slick-next slick-arrow"'
                + ' viewBox="0 0 26 26">'
                + '<use xmlns:xlink="http://www.w3.org/1999/xlink"'
                + ' xlink:href="#arrow-right">'
                + '</use></svg>',
      useTransform: true,
    });
  }

  function removeSlick() {
    if ($accessoriesSliders) {
      $($element).slick('unslick');
    }
  }

  function attachResize() {
    $(window).off('resize', resize);
    $(window).resize(resize);
  }

  function resize() {
    var width = window.innerWidth;

    if (width < Constants.breakpoints.lg && currentBreakpoint !== 'small') {
      currentBreakpoint = 'small';
      initSlick();
      ResponsiveBackground.execute();
    } else if (width >= Constants.breakpoints.lg
        && currentBreakpoint !== 'large') {
      currentBreakpoint = 'large';
      removeSlick();
    }
  }

  function init() {
    attachResize();
    resize();
  }

  return {
    init: init,
  };
};
